import { Product } from "@/types/types.ts";
import { FREE_DELIVERY_THRESHOLD_DMS_IDS } from "@/constants/constants";

export const isEligibleForFreeDelivery = (product: Product) => {
  const availableOptions = product.fulfilmentOptions?.available ?? [];
  return availableOptions.some((option) =>
    FREE_DELIVERY_THRESHOLD_DMS_IDS.includes(option.aliases.dmsId),
  );
};
